import {
	ReactNode,
	createContext,
	useContext,
	useEffect,
	useMemo,
	useState
} from "react";

type TypeFieldTenants = {
	label: string;
	value: string;
	text: string;
};

interface TenantContextType {
	tenant: TypeFieldTenants | undefined;
	setTenant: (tenant: TypeFieldTenants) => void;
}

interface TenantProviderProps {
	children: ReactNode;
}

const TenantContext = createContext<TenantContextType | undefined>(undefined);

export function TenantProvider({ children }: TenantProviderProps) {
	const takeLocalStorage = () => {
		const savedTenant = localStorage.getItem("tenant");
		return savedTenant ? JSON.parse(savedTenant) : undefined;
	};
	const [tenant, setTenant] = useState<TypeFieldTenants | undefined>(
		takeLocalStorage
	);

	useEffect(() => {
		if (tenant) {
			localStorage.setItem("tenant", JSON.stringify(tenant));
		} else {
			localStorage.removeItem("tenant");
		}
	}, [tenant]);

	const contextValue = useMemo(
		() => ({ tenant, setTenant }),
		[tenant, setTenant]
	);

	return (
		<TenantContext.Provider value={contextValue}>
			{children}
		</TenantContext.Provider>
	);
}

export const useTenant = () => {
	const context = useContext(TenantContext);
	if (!context) {
		throw new Error("useTenant must be used within a TenantProvider");
	}
	return context;
};
